import firebase from 'firebase/app'
import Vue from 'vue'

// eslint-disable-next-line unicorn/numeric-separators-style
const ONE_DAY_IN_MILLIS = 86400000

Vue.mixin({
  methods: {
    isUrgent: function (t: firebase.firestore.Timestamp): boolean {
      return t.toMillis() - ONE_DAY_IN_MILLIS < Date.now() // Less than 1 day
    }
  }
})
